import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import OrderBookModal from '../../../components/projectmng/obtainorder/OrderBookModal';
import * as fileApi from '../../../lib/api/file';
import * as projectApi from '../../../lib/api/project';
import * as approvalApi from '../../../lib/api/approval';
import AskDialog from '../../../components/common/dialog/AskDialog';
import {
  setOrderLetter,
  unloadOrderLetter,
  viewOrderLetter,
} from '../../../modules/projectModule/orderAdd';
import _ from 'lodash';
import { listOrderLetters } from '../../../modules/projectModule/orderLetters';

const OrderBookEditModalContainer = ({ roUuid, type, open, handleClose }) => {
  
  const { enqueueSnackbar } = useSnackbar();
  const [apprUuid, setApprUuid] = useState(null);
  const dispatch = useDispatch();
  const scollToRef = useRef();
  const [isAuth, setIsAuth] = useState(false);

  const {
    project,
    receiveOrderInf,
    billInfList,
    salesDetails,
    purchaseDetails,
    user,
    approvalLine,
    approvalList,
  } = useSelector(({ auth, projectModule, loading }) => ({
    user: auth.user,
    project: projectModule.project.project,
    approvalLine: projectModule.orderAdd.apprUuid,
    receiveOrderInf: projectModule.orderAdd.receiveOrderInf,
    billInfList: projectModule.orderAdd.billInfList,
    salesDetails: projectModule.orderAdd.salesDetails,
    purchaseDetails: projectModule.orderAdd.purchaseDetails,
    approvalList: projectModule.orderAdd.approvalList,
    message: projectModule.orderAdd.message,
    loading: loading['orderAdd/VIEW_ORDER_LETTER'],
  }));

  useEffect(() => {
    //수주정보 가져오기
    if (roUuid) {
      dispatch(viewOrderLetter(roUuid));
    }

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadOrderLetter());
    };
  }, [dispatch, roUuid]);

  useEffect(() => {
    if (approvalLine) {
      setApprUuid(approvalLine);
    }
  }, [approvalLine]);

  useEffect(() => {
    const findIndex = _.findIndex(
      user?.privilegeList,
      (auth) => auth?.authTyp === 'MINUS_PO' && auth?.authYn === 'Y',
    );
    
    if (findIndex !== -1) {
      setIsAuth(true);
    }
  }, [user]);

  const getPercentByTotal = (newValue) => {
    const totalSales = project?.totalSales; //매출액
    const numberValue = Number(newValue);
    const percent = Math.round((numberValue / totalSales) * 100);
    return percent;
  };

  const initialValues = {
    mtnFreeTm:
      receiveOrderInf && receiveOrderInf.mtnFreeTm !== null
        ? receiveOrderInf.mtnFreeTm
        : '',
    expDay:
      receiveOrderInf && receiveOrderInf.expDay !== null
        ? receiveOrderInf.expDay
        : '',
    siDt:
      receiveOrderInf && receiveOrderInf.siDt !== null
        ? receiveOrderInf.siDt
        : '',

    mtnFreeStrtDt:
      receiveOrderInf && receiveOrderInf.mtnFreeStrtDt !== null
        ? receiveOrderInf.mtnFreeStrtDt
        : '',
    mtnFreeEndDt:
      receiveOrderInf && receiveOrderInf.mtnFreeEndDt !== null
        ? receiveOrderInf.mtnFreeEndDt
        : '',

    collCondt:
      receiveOrderInf && receiveOrderInf.collCondt !== null
        ? receiveOrderInf.collCondt
        : '세금계산서 발행후 익월말',
    payCondt:
      receiveOrderInf && receiveOrderInf.payCondt !== null
        ? receiveOrderInf.payCondt
        : '현금',
    comment:
      receiveOrderInf && receiveOrderInf.comment !== null
        ? receiveOrderInf.comment
        : '',
    //최종 매출 이익 (내부거래 포함)
    roProfitAmt:
      receiveOrderInf && receiveOrderInf.roProfitAmt !== null
        ? receiveOrderInf.roProfitAmt
        : project?.totalProfit,
    roProfitAmtPercent:
      receiveOrderInf && receiveOrderInf.roProfitAmtPercent !== null
        ? receiveOrderInf.roProfitAmtPercent
        : getPercentByTotal(project?.totalProfit),
    roCostAmt:
      receiveOrderInf && receiveOrderInf.roCostAmt !== null
        ? receiveOrderInf.roCostAmt
        : 0,
    roCostAmtPercent:
      receiveOrderInf && receiveOrderInf.roCostAmtPercent !== null
        ? receiveOrderInf.roCostAmtPercent
        : 0,
    roAdjProfitAmt:
      receiveOrderInf && receiveOrderInf.roAdjProfitAmt !== null
        ? receiveOrderInf.roAdjProfitAmt
        : 0,
    roAdjProfitAmtPercent:
      receiveOrderInf && receiveOrderInf.roAdjProfitAmtPercent !== null
        ? receiveOrderInf.roAdjProfitAmtPercent
        : 0,
    roInternalCosts:
      receiveOrderInf && receiveOrderInf.roInternalCosts !== null
        ? receiveOrderInf.roInternalCosts
        : [
            {
              roPartnerUsrNm: '',
              roPartnerUsr: '',
              roInternalAmt: 0,
              roInternalAmtPercent: 0,
            },
          ],
    files: [{ fileDesc: '', file: null }],
  };

  const validationSchema = yup.object({
    expDay: yup
      .date('계약일을 입력하세요')
      .required('계약일을 입력하세요')
      .nullable()
      .default(undefined),
    siDt: yup
      .date('계약완료일을 입력하세요')
      .required('계약완료일을 입력하세요')
      .nullable()
      .default(undefined),
    mtnFreeStrtDt: yup
      .date()
      .test(
        'project-mtnFreeStrtDt',
        '무상 유지보수 시작일을 입력하세요',
        function (value) {
          let result = project?.prjTyp === 'N' && value === null ? false : true;
          return result;
        },
      )
      .nullable()
      .default(undefined),
    mtnFreeEndDt: yup
      .date()
      .test(
        'project-mtnFreeEndDt',
        '무상 유지보수 종료일을 입력하세요',
        function (value) {
          let result = project?.prjTyp === 'N' && value === null ? false : true;
          return result;
        },
      )
      .nullable()
      .min(yup.ref('mtnFreeStrtDt'), '무상유지보수 종료일을 확인하세요')
      .default(undefined),

    collCondt: yup.string().nullable(''),
    payCondt: yup.string().nullable(''),
    comment: yup.string().nullable(''),

    // 사용자 권한(MINUS_PO)이 있다면 min 적용 안함. 권한 없으면 min 적용
    /*
    roProfitAmt: yup
      .number()
      .test('roProfitAmt-min', '최소 0이상 입력하세요', function (value) {
        const result = !isAuth && value < 0 ? false : true;
        return result;
      }),
    roCostAmt: yup
      .number()
      .test('roCostAmt-min', '최소 0이상 입력하세요', function (value) {
        const result = !isAuth && value < 0 ? false : true;
        return result;
      }),
      */
    roInternalCosts: yup.array().of(
      yup.object().shape({
        roPartnerUsrNm: yup
          .string('')
          .when('roInternalAmt', (roInternalAmt, schema) => {
            if (roInternalAmt)
              return schema.required('협업담당자를 입력하세요');
          }),
        roInternalAmt: yup
          .number()
          .test('roInternalAmt-min', '최소 0이상 입력하세요', function (value) {
            const result = !isAuth && value < 0 ? false : true;
            return result;
          }),
      }),
    ),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      if (!apprUuid || apprUuid === 'undefined') {
        setMessage('결재선이 선택되지 않았습니다. 결재선을 선택하세요');
        setVisible(true);
        return;
      }

      onEditOrder(values);
      onClose();
      setSubmitting(false);
    },
  });

  //valid 가 맞지 않을 때 스크롤.
  useEffect(() => {
    if (!formik?.isValid) {
      scollToRef.current?.scrollIntoView();
    }
  }, [formik?.isValid]);

  function getReceiveOrderInf(values) {
    // const dateDif = dayjs(values.mtnFreeEndDt) - dayjs(values.mtnFreeStrtDt);
    // const cDay = 24 * 60 * 60 * 1000;
    // const cMonth = cDay * 30; // 월 만듬
    // const difMonth = Math.ceil(dateDif / cMonth);

    let ReceiveOrderInf = {
      roUuid: receiveOrderInf.roUuid,
      prjUuid: receiveOrderInf.prjUuid,
      partnerUuid: receiveOrderInf.partnerUuid,
      employeeUuid: receiveOrderInf.employeeUuid,
      partnerInc: receiveOrderInf.partnerInc,
      chargeNm: receiveOrderInf.chargeNm,
      salesUuid: receiveOrderInf.salesUuid,
      //mtnFreeTm: difMonth,
      collCondt: values.collCondt,
      payCondt: values.payCondt,
      comment: values.comment,
      expDay: values.expDay ? dayjs(values.expDay).format('YYYY-MM-DD') : null,
      siDt: values.siDt ? dayjs(values.siDt).format('YYYY-MM-DD') : null,
      mtnFreeStrtDt: values.mtnFreeStrtDt
        ? dayjs(values.mtnFreeStrtDt).format('YYYY-MM-DD')
        : null,
      mtnFreeEndDt: values.mtnFreeEndDt
        ? dayjs(values.mtnFreeEndDt).format('YYYY-MM-DD')
        : null,
      roProfitAmt: values.roProfitAmt, //매출이익
      roProfitAmtPercent: values.roProfitAmtPercent, //매출이익 퍼센트
      roCostAmt: values.roCostAmt,
      roCostAmtPercent: values.roCostAmtPercent,
      roAdjProfitAmt: values.roAdjProfitAmt,
      roAdjProfitAmtPercent: values.roAdjProfitAmtPercent,

      roInternalCosts: values.roInternalCosts, //내부거래비용array

      roTotalAmt: project.totalSales, //총 매출액
    };    
    return ReceiveOrderInf;
  }

  const onFileSave = async (value, orderInfo) => {
    let formData = new FormData();
    formData.append('fileDt', value.file);
    formData.append('fileTyp', 'PROJECT_PO');
    formData.append('fileAttrVal1', orderInfo.prjUuid);
    formData.append('fileAttrVal2', '수주품의서');
    formData.append('fileAttrVal3', orderInfo.roUuid);
    formData.append('fileDesc', value.fileDesc);

    try {
      const response = await fileApi.addFiles(formData);

      if (response.data.result === 'success') {
        enqueueSnackbar('수주품의서 파일 업로드 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const onEditOrder = async (values) => {
    const orderLetterInfo = getReceiveOrderInf(values);
    
    let dataToSubmit = {
      receiveOrderInf: orderLetterInfo,
      billInfList: billInfList,
      apprUuid: apprUuid,
    };

    try {
      const res = await projectApi.editReceiveOrder(roUuid, dataToSubmit);

      if (res.data) {
        //실제 업로드 파일이 있다면
        if (values.files.length > 0 && values.files[0].file !== null) {
          values.files.forEach((value) => {
            onFileSave(value, res.data.receiveOrderInf);
          });
        }

        dispatch(setOrderLetter(res.data));
        enqueueSnackbar(`수주품의서 저장 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState(null);

  const onCancle = () => {
    setVisible(false);
  };

  const onConfirm = () => {
    setVisible(false);
  };

  const onClose = () => {
    formik.resetForm();
    handleClose();
  };

  const [removeVisible, setRemoveVisible] = useState(false);
  const handleDelete = () => {
    setRemoveVisible(true);
  };
  const onDeleteCancle = () => {
    setRemoveVisible(false);
  };
  const onDeleteConfirm = () => {
    //삭제
    handleDeleteAppr();
    setRemoveVisible(false);
  };

  const handleDeleteAppr = async () => {
    const docuId = approvalList[0]?.docuUuid;
    
    try {
      const res = await approvalApi.deleteApproval(docuId);

      if (res.data.result === 'success') {
        dispatch(listOrderLetters(project.prjUuid));
        onClose();
        enqueueSnackbar('결제가 삭제되었습니다', {
          variant: 'success',
        });
      } else {
        enqueueSnackbar('결제 삭제에 실패하였습니다.', {
          variant: 'error',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <>
      <OrderBookModal
        type={type}
        open={open}
        project={project}
        handleClose={onClose}
        orderInfo={receiveOrderInf}
        formik={formik}
        user={user}
        apprUuid={apprUuid}
        setApprUuid={setApprUuid}
        approvalList={approvalList}
        scollToRef={scollToRef}
        salesDetails={salesDetails}
        purchaseDetails={purchaseDetails}
        onDeleteApproval={handleDelete}
      />
      <AskDialog
        visible={visible}
        title="확인"
        description={message}
        confirmText="확인"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
      <AskDialog
        visible={removeVisible}
        title="결재 삭제"
        description="해당 결재를  삭제 처리 하시겠습니까?(복구 불가)"
        onConfirm={onDeleteConfirm}
        onCancle={onDeleteCancle}
      />
    </>
  );
};

export default OrderBookEditModalContainer;
